<template>
  <div>
    <section class="bg-custom authContainer">
      <div
        class="main-popup visible shadow-custom bg-white rounded-lg pb-4 mb-4"
      >
        <div class="popup-header text-center">
          <div class="content">Create your Free Account</div>
          <router-link to="/" class="d-block">
            <img
              class="img-fluid"
              src="/assets/images/brand1.png"
              width="180px"
              id="brand-logo"
            />
          </router-link>
        </div>
        <div class="popup-content">
          <div
            v-if="alert.message"
            :key="Math.random()"
            :class="'rounded-0 text-center alert ' + alert.type"
          >
            {{ alert.message }}
          </div>
          <div
            v-else
            class="notifier mb-2 position-relative text-center bg-light p-2"
          >
            Please enter your valid credentials to continue.
          </div>
          <form action="#" class="pt-1 px-4">
            <div class="form-content pt-0 w-100">
              <div class="form-group">
                <input
                  type="text"
                  v-validate="'required|digits:11'"
                  name="phone"
                  placeholder="Enter your phone number"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && errors.has('phone') }"
                  v-model="user.username"
                />
                <div
                  v-if="submitted && errors.has('phone')"
                  class="small invalid-feedback"
                >
                  {{ errors.first("phone") }}
                </div>
              </div>
              <div class="form-group" v-if="false">
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  class="form-control"
                  v-validate="'required|email'"
                  :class="{ 'is-invalid': submitted && errors.has('email') }"
                  v-model="user.email"
                />
                <div
                  v-if="submitted && errors.has('email')"
                  class="small invalid-feedback"
                >
                  {{ errors.first("email") }}
                </div>
              </div>
              <div class="form-group">
                <select
                  v-model="user.account_type"
                  name="account_type"
                  class="form-control"
                  v-validate="'required'"
                  :class="{
                    'is-invalid': submitted && errors.has('account_type')
                  }"
                >
                  <option value>Choose Account Type</option>
                  <option value="aggregator">Aggregrator</option>
                  <option value="farmer">Farmer</option>
                  <option value="business">Signup as Business</option>
                  <option value="individual">Signup as Individual</option>
                </select>
                <div
                  v-if="submitted && errors.has('account_type')"
                  class="small invalid-feedback"
                >
                  The account type field is required.
                </div>
              </div>
              <div class="form-group" v-if="user.account_type == 'aggregator'">
                <select
                  v-model="user.aggregator_type"
                  name="aggregator_type"
                  class="form-control"
                  v-validate="'required'"
                  :class="{
                    'is-invalid': submitted && errors.has('aggregator_type')
                  }"
                >
                  <option value>Choose Aggregrator Type</option>
                  <option value="aggregator">Aggregrator</option>
                  <option value="warehouse_provider">WareHouse Provider</option>
                  <option value="trader">Trader</option>
                  <option value="input_provider">Input Provider</option>
                  <option value="trucker">Trucker</option>
                  <option value="processor">Processor</option>
                </select>
                <div
                  v-if="submitted && errors.has('aggregator_type')"
                  class="small invalid-feedback"
                >
                  The aggregator type field is required.
                </div>
              </div>
              <div class="form-group" v-if="user.account_type == 'aggregator'">
                <input
                  type="text"
                  name="aggregator_code"
                  placeholder="Enter your aggregator code"
                  class="form-control"
                  v-model="user.aggregator_code"
                />
              </div>
              <div class="form-group">
                <input
                  type="password"
                  name="password"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && errors.has('password') }"
                  v-validate="{ required: true, min: 6 }"
                  v-model="user.password"
                  placeholder="Enter your password"
                  ref="password"
                />
                <div
                  v-if="submitted && errors.has('password')"
                  class="small invalid-feedback"
                >
                  {{ errors.first("password") }}
                </div>
              </div>
              <div class="form-group">
                <input
                  type="password"
                  name="password_confirmation"
                  placeholder="Confirm your Password"
                  class="form-control"
                  :class="{
                    'is-invalid':
                      submitted && errors.has('password_confirmation')
                  }"
                  v-validate="'required|confirmed:password'"
                  v-model="user.password_confirmation"
                  data-vv-as="password"
                />
                <div
                  v-if="submitted && errors.has('password_confirmation')"
                  class="small invalid-feedback"
                >
                  {{ errors.first("password_confirmation") }}
                </div>
              </div>
              <div class="form-group">
                <div class="custom-control custom-checkbox my-1 mr-sm-2 ml-2">
                  <input
                    type="checkbox"
                    id="accept-terms"
                    name="agree"
                    class="custom-control-input"
                    v-validate="'required'"
                    :class="{
                      'is-invalid': submitted && errors.has('agree')
                    }"
                    v-model="user.agree"
                  />
                  <label class="custom-control-label" for="accept-terms">
                    I agree to the
                    <router-link class="primary_link" to="/legal"
                      >Terms & Conditions</router-link
                    >
                  </label>
                  <div
                    v-if="submitted && errors.has('agree')"
                    class="small invalid-feedback"
                  >
                    You need to agree to our terms and conditions to proceed
                  </div>
                </div>
              </div>
              <!-- <ul>
                <li v-for="error in errors.all()" :key="error">{{ error }}</li>
              </ul> -->
              <div class="form-group">
                <button
                  type="submit"
                  :disabled="status.registering"
                  class="btn btn-dark btn-pill btn-block py-2"
                  @click="handleSubmit"
                >
                  <span v-if="status.registering" class="donutSpinner"></span>
                  <span v-else>Create your Account</span>
                </button>
              </div>
              <div class="text-center">
                Already a member?
                <router-link to="/login" class="primary_link"
                  >Sign In to your Account</router-link
                >
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Signup",
  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | Sign Up",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  data() {
    return {
      user: {
        email: "",
        username: "",
        password: "",
        password_confirmation: "",
        account_type: "",
        aggregator_type: "",
        aggregator_code: null,
        agree: null
      },
      submitted: false
    };
  },
  created() {
    this.clearAlert();
  },
  computed: {
    ...mapState("account", ["status"]),
    ...mapState({
      alert: state => state.alert
    })
  },
  methods: {
    ...mapActions("account", ["register"]),
    ...mapActions({
      clearAlert: "alert/clear"
    }),

    handleSubmit(e) {
      e.preventDefault();

      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          // destructure the object to return the ones needed  rest using the rest operators
          const {
            email,
            password_confirmation,
            aggregator_code,
            aggregator_type,
            agree,
            ...credentials
          } = this.user;

          this.register(credentials);
        }
      });
    }
  }
};
</script>
